import { Pipe, PipeTransform } from '@angular/core';

/**
 * Angular pipe that extracts the initial letters from a string.
 *
 * ```html
 *   {{ 'John Doe' | initials }}           // 'J'
 *   {{ 'John Doe' | initials:2 }}         // 'JD'
 * ```
 */
@Pipe({
  name: 'initials'
})
export class InitialsPipe implements PipeTransform {

  /**
   * Transforms a full name or string into a string of initials.
   *
   * @param value - The input string to transform (e.g., a full name).
   * @param numberOfInitials - The number of initials to extract. Defaults to 1.
   * @returns A string of uppercase initials, or an empty string if input is empty.
   */
  transform(value: string, numberOfInitials: number = 1): string {
    // If empty, return empty string
    if (!value) {
      return '';
    }

    const words = value.split(' ');

    const initials = words.slice(0, numberOfInitials).map(word => word.charAt(0).toUpperCase());

    return initials.join('');
  }
}
